import Enum from '@/modules/core/app/helpers/Enum';
import { FinancialAccountTransactionCategory } from '@/modules/financialaccount/enums/FinancialAccountTransactionCategory';
import Lang from '@/modules/core/app/services/Lang';
import { FinancialAccountTransactionCategoryRelationshipKey } from '@/modules/accounting/types/FinancialAccountTransactionCategoryRelationshipKey';
import { ModelType } from '@/modules/core/app/constants/ModelType';

export class FinancialAccountTransactionCategoryType extends Enum {
  key!: FinancialAccountTransactionCategory | null;
  value!: string;
  color!: string;
  requiresRelationship!: boolean;
  categoryRelationshipKey!: FinancialAccountTransactionCategoryRelationshipKey;
  categoryRelationshipChangeText?: string;

  static UNCATEGORIZED: FinancialAccountTransactionCategoryType = {
    key: null,
    get value(): string {
      return Lang.t('financialaccount.uncategorized');
    },
    color: '#7E84A3',
    requiresRelationship: false,
    categoryRelationshipKey: null
  };

  static EXPENSE: FinancialAccountTransactionCategoryType = {
    key: FinancialAccountTransactionCategory.EXPENSE,
    get value(): string {
      return Lang.t('financialaccount.expenses');
    },
    color: '#F97068',
    requiresRelationship: false,
    categoryRelationshipKey: ModelType.LIABILITY,
    get categoryRelationshipChangeText(): string {
      return Lang.t('financialaccount.change-expense');
    }
  };

  static REVENUE: FinancialAccountTransactionCategoryType = {
    key: FinancialAccountTransactionCategory.REVENUE,
    get value(): string {
      return Lang.t('financialaccount.revenue');
    },
    color: '#60C49D',
    requiresRelationship: false,
    categoryRelationshipKey: ModelType.ASSET,
    get categoryRelationshipChangeText(): string {
      return Lang.t('financialaccount.change-revenue');
    }
  };

  static ASSET_LIQUIDATION: FinancialAccountTransactionCategoryType = {
    key: FinancialAccountTransactionCategory.ASSET_LIQUIDATION,
    get value(): string {
      return Lang.t('financialaccount.asset-liquidation');
    },
    color: '#7BDBFF',
    requiresRelationship: true,
    categoryRelationshipKey: ModelType.ASSET,
    get categoryRelationshipChangeText(): string {
      return Lang.t('financialaccount.change-asset-liquidation');
    }
  };

  static DEBT_REPAYMENT: FinancialAccountTransactionCategoryType = {
    key: FinancialAccountTransactionCategory.DEBT_REPAYMENT,
    get value(): string {
      return Lang.t('financialaccount.debt-repayment');
    },
    color: '#7BDBFF',
    requiresRelationship: true,
    categoryRelationshipKey: ModelType.LIABILITY,
    get categoryRelationshipChangeText(): string {
      return Lang.t('financialaccount.change-debt-repayment');
    }
  };

  static CASH_DISTRIBUTION: FinancialAccountTransactionCategoryType = {
    key: FinancialAccountTransactionCategory.CASH_DISTRIBUTION,
    get value(): string {
      return Lang.t('financialaccount.cash-distribution');
    },
    color: '#9747FF',
    requiresRelationship: true,
    categoryRelationshipKey: ModelType.ESTATE_ACCOUNT,
    get categoryRelationshipChangeText(): string {
      return Lang.t('financialaccount.change-cash-distribution');
    }
  };
}
